import React from 'react'
import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'
import bookdetails from '../Assets/workshop down.jpg'

function Service5() {
  return (
    <>
    <Navbar/>
    <div className='aboutbanner aboutbanner7'>
    <h3>Special Events & Experiences</h3>
    {/* <p>Escape, Recharge & Renew</p> */}

    </div>
    <div className='about-classes'>
    <div className='about-classes-left'>
    {/* <h3>A gentle, nurturing space for emotional healing and inner peace.</h3> */}
    <p>We regularly host unique events designed to inspire growth, connection, and self-discovery.</p>

    {/* <p>This practice soothes the nervous system, reduces anxiety, and promotes feelings of safety, comfort, and calm. It's perfect for those navigating change, experiencing burnout, or seeking a grounding space for self-care.</p> */}

    
    <ul>
    <li><b>New Moon Rebirth </b> Embrace new beginnings with this powerful session designed to welcome fresh energy and positive change.</li>
    <li><b>Moonlight Release</b> A soothing experience that encourages you to release old energy and invite clarity into your life.</li>
    <li><b>Acro Yoga </b>A fun and interactive partner-based session that combines strength, trust, and balance.</li>
    <li><b>Pilates & Brunch </b>Strengthen your body and nourish your soul with this energizing workout followed by a wholesome brunch.</li>
    <li><b>Breathwork & Ice Bath Experience </b> Inspired by Wim Hof’s techniques, this transformative session combines powerful breathwork with a refreshing ice plunge to promote mental clarity and resilience.</li>

    </ul>
    {/* <p><b>Find Your Practice, Embrace Your Journey </b></p>
    <p>At Alura, we believe there’s no ‘one-size-fits-all’ when it comes to wellness. Whether you need energy, calm, strength, or stillness, our classes are designed to support your unique journey.</p>
 */}


    

    
</div>
   <div className='about-classes-right'>
<img src={bookdetails}/>
 

</div>
    </div>
    <Footer/>
   </>
  )
}

export default Service5